import React from 'react';
import { DualAxes } from '@ant-design/plots';
import { TemperatureGraphInterface } from '@app/types/rooms';
import { TEMP_ENERGY_SHORTCUTS } from '@app/constants';
import { intervalFormatter } from '@app/utils/helpers';

const MeasurementsGraph = ({ measurements }: TemperatureGraphInterface) => {
  if (!measurements) return null;
  const config = {
    data: [measurements, measurements],
    xField: 'dt',
    yField: ['temp', 'energy'],
    slider: {
      start: 0,
      end: 1,
      formatter: intervalFormatter
    },
    smooth: true,
    meta: {
      temp: {
        alias: TEMP_ENERGY_SHORTCUTS.TEMPERATURE,
        formatter: kWh => {
          return kWh?.toFixed(2);
        }
      },
      energy: {
        alias: TEMP_ENERGY_SHORTCUTS.ENERGY
      },
      date: {
        formatter: intervalFormatter
      }
    },
    geometryOptions: [
      {
        geometry: 'line',
        color: '#5B8FF9'
      },
      {
        geometry: 'line',
        color: '#5AD8A6'
      }
    ]
  };

  return <DualAxes {...config} />;
};

export default MeasurementsGraph;
